// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.testing-qa-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 70px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  gap: 20px;
}

.testing-qa-text {
  width: 60%;
  order: 1;
  border-radius: -150;
  margin-bottom: 100px;
}

.testing-qa-image {
  position: relative;
  width: 34%;
  order: 2;
  padding: 10px 0;
  margin-top: 0;
}

.services-image {
  width: 100%;
  height: auto;
  border-radius: 8px;
}

.services-list {
  list-style: none;
  padding: 0;
  margin: 0;
  line-height: 1.5;
}

.services-list ul {
  margin-top: 5px;
  margin-bottom: 15px;
  padding-left: 20px;
}

.services-list li {
  margin-bottom: 10px;
}
.testing-qa-text h1 {
  font-size: 2rem;
  color: #000;
  margin-bottom: 10px;
}
.testing-qa-text h2 {
  font-size: 1.5rem;
  color: #555;
  margin-bottom: 10px;
}

@media (max-width: 768px) {
  .testing-qa-container {
    flex-direction: column;
    align-items: center;
    text-align: left;
    gap: 20px;
  }

  .testing-qa-text {
    width: 130%;
    margin-top: -40px;
  }
  .testing-qa-text h1 {
    width: 100%;
  }

  .testing-qa-image {
    position: relative;
    margin-top: 70px;
    width: 130%;
    order: 0;
  }

  .services-image {
    width: 290%;
    height: auto;
  }
}

@media screen and (min-width: 1380px) and (max-width: 1919px) {
  .testing-qa-container {
    padding: 100px;
    gap: 15px;
  }

  .testing-qa-text {
    margin-bottom: 80px;
  }

  .testing-qa-text h1 {
    font-size: 1.8rem;
  }

  .testing-qa-text h2 {
    font-size: 1.3rem;
  }

  .testing-qa-image {
    width: 32%;
  }

  .services-list li {
    font-size: 0.95rem;
  }
}

@media screen and (min-width: 1920px) {
  .testing-qa-container {
    padding: 80px;
    gap: 25px;
  }

  .testing-qa-text {
    margin-bottom: 120px;
  }

  .testing-qa-text h1 {
    font-size: 2.2rem;
  }

  .testing-qa-text h2 {
    font-size: 1.7rem;
  }

  .testing-qa-image {
    width: 32%;
  }

  .services-list li {
    font-size: 1.1rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/TestingAndQA/TestingAndQA.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,SAAS;AACX;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,eAAe;EACf,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,iBAAiB;EACnB;EACA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,cAAc;IACd,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".testing-qa-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 70px;\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  gap: 20px;\n}\n\n.testing-qa-text {\n  width: 60%;\n  order: 1;\n  border-radius: -150;\n  margin-bottom: 100px;\n}\n\n.testing-qa-image {\n  position: relative;\n  width: 34%;\n  order: 2;\n  padding: 10px 0;\n  margin-top: 0;\n}\n\n.services-image {\n  width: 100%;\n  height: auto;\n  border-radius: 8px;\n}\n\n.services-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  line-height: 1.5;\n}\n\n.services-list ul {\n  margin-top: 5px;\n  margin-bottom: 15px;\n  padding-left: 20px;\n}\n\n.services-list li {\n  margin-bottom: 10px;\n}\n.testing-qa-text h1 {\n  font-size: 2rem;\n  color: #000;\n  margin-bottom: 10px;\n}\n.testing-qa-text h2 {\n  font-size: 1.5rem;\n  color: #555;\n  margin-bottom: 10px;\n}\n\n@media (max-width: 768px) {\n  .testing-qa-container {\n    flex-direction: column;\n    align-items: center;\n    text-align: left;\n    gap: 20px;\n  }\n\n  .testing-qa-text {\n    width: 130%;\n    margin-top: -40px;\n  }\n  .testing-qa-text h1 {\n    width: 100%;\n  }\n\n  .testing-qa-image {\n    position: relative;\n    margin-top: 70px;\n    width: 130%;\n    order: 0;\n  }\n\n  .services-image {\n    width: 290%;\n    height: auto;\n  }\n}\n\n@media screen and (min-width: 1380px) and (max-width: 1919px) {\n  .testing-qa-container {\n    padding: 100px;\n    gap: 15px;\n  }\n\n  .testing-qa-text {\n    margin-bottom: 80px;\n  }\n\n  .testing-qa-text h1 {\n    font-size: 1.8rem;\n  }\n\n  .testing-qa-text h2 {\n    font-size: 1.3rem;\n  }\n\n  .testing-qa-image {\n    width: 32%;\n  }\n\n  .services-list li {\n    font-size: 0.95rem;\n  }\n}\n\n@media screen and (min-width: 1920px) {\n  .testing-qa-container {\n    padding: 80px;\n    gap: 25px;\n  }\n\n  .testing-qa-text {\n    margin-bottom: 120px;\n  }\n\n  .testing-qa-text h1 {\n    font-size: 2.2rem;\n  }\n\n  .testing-qa-text h2 {\n    font-size: 1.7rem;\n  }\n\n  .testing-qa-image {\n    width: 32%;\n  }\n\n  .services-list li {\n    font-size: 1.1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
